import "./Document.scss"
import PageLayout from "../../components/PageLayout/PageLayout";
import {useParams} from "react-router-dom";
import {useEffect} from "react";
import {useFormik} from "formik";
import DocumentActions from "../../api/DocumentActions";
import {documentIcon} from "../../components/Icon/Icon";
import CheckpointsListProvider from "../../contexts/checkpointsListContext/CheckpointsListContext";
import VariablesProvider from "../../contexts/variablesContext/VariablesContext";
import DocumentEditor from "../../components/DocumentEditor/DocumentEditor";

const Document = () => {
    const {id} = useParams();

    const formik = useFormik({
        initialValues: {
            name: null,
        },
    });

    useEffect(() => {
        if(!id) return;

        DocumentActions.get(id, res => {
            formik.setValues(res)
        })

    }, [id]);

    if(!formik.values.id) return "";

    return (
        <PageLayout
            titlePage="Documents"
            icon={documentIcon}
            titlePageContent={formik.values.name}
            className="document-page"
        >
            <div className="document">
                <CheckpointsListProvider>
                    <VariablesProvider>
                        <DocumentEditor formik={formik} />
                    </VariablesProvider>
                </CheckpointsListProvider>
            </div>
        </PageLayout>
    )
}

export default Document;